import api from '..';
import config from '../../config';

export const getCoupons = (params, auth, setAuth) => {
  return api.get(`${config.snapPopPath}/coupon_instances`, params, auth, setAuth);
};

export const issueCoupon = (couponTemplateId, auth, setAuth) => {
  return api.post(`${config.snapPopPath}/coupon_templates/${couponTemplateId}/issue`, null, auth, setAuth);
};

export const redeemCoupon = (couponId, storeCode, auth, setAuth) => {
  const body = { store_code: storeCode };
  return api.post(`${config.snapPopPath}/coupon_instances/${couponId}/redeem`, body, auth, setAuth);
};
